import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionResultEntryForm from '../../../components/forms/CompetitionResultEntryForm';
import { useCreateCompetitionResultEntry } from '../../../hooks/useCompetitionResultEntryApi';
import { useNavigate } from 'react-router-dom';
import { CompetitionResultEntryDTO } from '../../../services/apiClient';

const CompetitionResultEntryCreate: React.FC = () => {
  const createCompetitionResultEntry = useCreateCompetitionResultEntry();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competition Result Entries', href: '/admin/competitionresultentries' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CompetitionResultEntryDTO) => {
    try {
      await createCompetitionResultEntry.mutateAsync(data);
      navigate('/admin/competitionresultentries');
    } catch (error) {
      console.error('Error creating CompetitionResultEntry:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionresultentries"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.CompetitionResultEntry.Edit'
    >
      <CompetitionResultEntryForm
        initialValues={{} as CompetitionResultEntryDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/competitionresultentries')}
      />
    </AdminLayout>
  );
};

export default CompetitionResultEntryCreate;
